var _defs, _path, _g, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProtection(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 100,
    viewBox: "0 0 75 75",
    height: 100,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.04.836h38.558v73.32H10.039Zm0 0"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#f9a92c",
    d: "M69.34 29.238 69 26.035l-17.473-6.492-17.52 6.512-.296 3.261c-1.273 13.961 3.625 24.356 14.977 31.766l2.886 1.883 2.856-1.926c11.48-7.73 16.355-18.133 14.91-31.8"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#f9a92c",
    d: "M33.086 74.156c-6.188 0-11.922-2.57-16.145-7.234-5.015-5.535-7.539-13.524-6.761-21.371C12.02 27.027 30.723 2.633 31.516 1.605c.375-.488.953-.77 1.57-.77a1.97 1.97 0 0 1 1.566.77c.184.239 4.586 5.957 9.407 13.98a1.983 1.983 0 0 1-3.398 2.043 165.445 165.445 0 0 0-7.575-11.48c-4.55 6.313-17.531 25.41-18.961 39.793-.672 6.754 1.48 13.602 5.754 18.32 2.45 2.708 6.73 5.934 13.207 5.934 4.582 0 8.777-1.672 12.125-4.836a1.981 1.981 0 0 1 2.8.082c.755.797.716 2.051-.077 2.801-4.102 3.871-9.235 5.914-14.848 5.914"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#f9a92c",
    d: "M25.86 62.691a1.972 1.972 0 0 1-1.567-.578c-2.977-2.996-4.914-7.195-5.324-11.52-.328-3.507.152-7.831 1.433-12.847a1.981 1.981 0 1 1 3.84.98c-1.168 4.575-1.613 8.442-1.324 11.497.32 3.425 1.848 6.742 4.187 9.097a1.98 1.98 0 0 1-.011 2.801 1.96 1.96 0 0 1-1.235.57"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProtection);
export default __webpack_public_path__ + "static/media/protection.f796112bcde759f02f1c4906cd98c34c.svg";
export { ForwardRef as ReactComponent };